import * as React from 'react';
import {
  Col, FormInput, FormSelect
} from "shards-react";
import {useEffect} from "react";
import CustomCard from "../common/CustomCard";
import {STANDARD_FORMATS} from "../../utils/constants";
import StandardFormInput from "../common/StandardFormInput";
import CRBadge from "../common/CRBadge";

export const ContactInfo = ({
                              countryList,
                              regionList,
                              cityList,
                              preferredEmailList,
                              get_region_list,
                              get_city_list,
                              addressLine1,
                              addressLine2,
                              addressType,
                              cityId,
                              countryId,
                              emailPersonal,
                              emailWork,
                              linkedIn,
                              phoneHome,
                              phoneMobile,
                              phoneWork,
                              phoneWorkExt,
                              preferredEmail,
                              regionId,
                              onChange,
                              onChangeStandardInput,
                              zip,
                              queryParamsRole,
                              workerFlag,
                              changeRequestedFields = {}
                            }) => {

  useEffect(() => {
    if (countryId) {
      get_region_list(countryId)
    }
  }, [countryId])

  useEffect(() => {
    if (regionId) {
      get_city_list(regionId)
    }
  }, [regionId])


  var preferredEmailListOption = preferredEmailList.map((email) => {
    return <option key={email} value={email}>{email}</option>;
  });

  var cityListOption = cityList.map((option) => {
    return <option key={option.cityId}
                   value={option.cityId}>{option.cityName}</option>;
  })
  var regionListOption = regionList.map((option) => {
    return <option key={option.stateProvId}
                   value={option.stateProvId}>{option.stateProvName}</option>;
  })
  var countryListOption = countryList.map((option) => {
    return <option key={option.countryId}
                   value={option.countryId}>{option.countryName}</option>;
  })

  return (
    <CustomCard id="contact" title="Contact Information"  icon={true} iconClass="fas fa-id-badge iconStyle" className={"userprofile mb-5 w-100 d-flex personalParent"} noform>
      
      {workerFlag && (<><Col lg="3" className="form-group m-0 p-2">
        <label htmlFor="addressType">
          Address Type
          {changeRequestedFields['contactInfo.addressType'] && <CRBadge newValue={changeRequestedFields['contactInfo.addressType'].newValue} />}
        </label>
        <FormSelect name='addressType'
                    value={addressType}
                    onChange={onChange} className='d-block'>
          <option value=''>Select Address Type</option>
          <option value='Permanent'>Permanent</option>
          <option value='Temporary'>Temporary</option>
        </FormSelect>
      </Col>
      <Col lg="3" className="form-group m-0 p-2"></Col>
      <Col lg="3" className="form-group m-0 p-2"></Col>
      <Col lg="3" className="form-group m-0 p-2"></Col></>)}
        { console.log("changeRequestedFields['contactInfo.addressLine1'] => ", changeRequestedFields) }
      {workerFlag && <Col lg="6" className="form-group m-0 p-2">
        <label htmlFor="addressline1">
          Address Line 1
          {changeRequestedFields['contactInfo.addressLine1'] && <CRBadge newValue={changeRequestedFields['contactInfo.addressLine1'].newValue} />}
        </label>
        <FormInput
          id="addressline1"
          placeholder="Enter Address Line 1"
          value={addressLine1}
          name='addressLine1'
          onChange={onChange}
        />
      </Col>}

      {workerFlag && <Col lg="6" className="form-group m-0 p-2">
        <label htmlFor="addressline2">
          Address Line 2
          {changeRequestedFields['contactInfo.addressLine2'] && <CRBadge newValue={changeRequestedFields['contactInfo.addressLine2'].newValue} />}
        </label>
        <FormInput
          id="addressline2"
          placeholder="Enter Address Line 2"
          value={addressLine2}
          name='addressLine2'
          onChange={onChange}
        />
      </Col>}

      {workerFlag && <Col lg="3" className="form-group m-0 p-2">
        <label htmlFor="country">
          Country
          {changeRequestedFields['contactInfo.countryId'] && <CRBadge newValue={changeRequestedFields['contactInfo.countryId'].newValue} />}
        </label>
        <span aria-hidden="true" className="required"> *</span>
        <FormSelect name='countryId'
                    required={true}
                    value={countryId}
                    onChange={onChange} className='d-block'>
          <option value=''>Select Country Name</option>
          {countryListOption}
        </FormSelect>
      </Col>}

      {workerFlag && <Col lg="3" className="form-group m-0 p-2">
        <label htmlFor="state">
          State/Province of Residence
          {changeRequestedFields['contactInfo.regionId'] && <CRBadge newValue={changeRequestedFields['contactInfo.regionId'].newValue} />}
        </label>
        <span aria-hidden="true" className="required"> *</span>
        <FormSelect name='regionId'
                    required={true}
                    value={regionId}
                    onChange={onChange} className='d-block'>
          <option value=''>Select State/Province</option>
          {regionListOption}
        </FormSelect>
      </Col>}

      {workerFlag && <Col lg="3" className="form-group m-0 p-2">
        <label htmlFor="city">
          City
          {changeRequestedFields['contactInfo.cityId'] && <CRBadge newValue={changeRequestedFields['contactInfo.cityId'].newValue} />}
        </label>
        <FormSelect name='cityId' value={cityId}
                    onChange={onChange} className='d-block'>
          <option value=''>Select City</option>
          {cityListOption}
        </FormSelect>
      </Col>}

      {workerFlag && <Col lg="3" className="form-group m-0 p-2">
        <label htmlFor="zipcode">
          ZIP/Postal Code
          {changeRequestedFields['contactInfo.zip'] && <CRBadge newValue={changeRequestedFields['contactInfo.zip'].newValue} />}
        </label>
        <FormInput
          id="zipcode"
          placeholder="Enter ZIP Code"
          value={zip}
          name='zip'
          onChange={onChange}
        />
      </Col>}

      {workerFlag && <StandardFormInput
        id="phoneHome"
        label={<>Phone - Home{changeRequestedFields['contactInfo.phoneHome'] && <CRBadge newValue={changeRequestedFields['contactInfo.phoneHome'].newValue} />}</>}
        placeholder="(xxx) xxx-xxxx"
        standardFormat={STANDARD_FORMATS.PHONE_NO}
        type="text"
        name='phoneHome'
        value={phoneHome}
        onChangeStandardInput={onChangeStandardInput}
      />}

      <StandardFormInput
        id="phoneWork"
        label={<>Phone - Work{changeRequestedFields['contactInfo.phoneWork'] && <CRBadge newValue={changeRequestedFields['contactInfo.phoneWork'].newValue} />}</>}
        placeholder="(xxx) xxx-xxxx"
        standardFormat={STANDARD_FORMATS.PHONE_NO}
        type="text"
        name='phoneWork'
        value={phoneWork}
        onChangeStandardInput={onChangeStandardInput}
      />

      {workerFlag && <Col lg="3" className="form-group m-0 p-2">
        <label htmlFor="phoneWorkExt">
          Phone - Work Ext
          {changeRequestedFields['contactInfo.phoneWorkExt'] && <CRBadge newValue={changeRequestedFields['contactInfo.phoneWorkExt'].newValue} />}
        </label>
        <FormInput
          id="phoneWorkExt"
          placeholder="xxxxx"
          type="number"
          min={5}
          value={phoneWorkExt}
          name='phoneWorkExt'
          onChange={onChange}
        />
      </Col>}

      {workerFlag && <StandardFormInput
        id="phoneMobile"
        label={<>Phone - Mobile{changeRequestedFields['contactInfo.phoneMobile'] && <CRBadge newValue={changeRequestedFields['contactInfo.phoneMobile'].newValue} />}</>}
        placeholder="(xxx) xxx-xxxx"
        standardFormat={STANDARD_FORMATS.PHONE_NO}
        type="text"
        name='phoneMobile'
        value={phoneMobile}
        onChangeStandardInput={onChangeStandardInput}
      />}

      {workerFlag && <Col lg="3" className="form-group m-0 p-2">
        <label htmlFor="emailPersonal">
          Email - Personal
          {changeRequestedFields['contactInfo.emailPersonal'] && <CRBadge newValue={changeRequestedFields['contactInfo.emailPersonal'].newValue} />}
        </label>
        <FormInput
          id="emailPersonal"
          placeholder="Enter Email - Personal"
          value={emailPersonal}
          name='emailPersonal'
          onChange={onChange}
        />
      </Col>}

      <Col lg="3" className="form-group m-0 p-2">
        <label htmlFor="emailWork">
          Email - Work
          {changeRequestedFields['contactInfo.emailWork'] && <CRBadge newValue={changeRequestedFields['contactInfo.emailWork'].newValue} />}
        </label>
        {!workerFlag && <span aria-hidden="true" className="required"> *</span>}
        <FormInput
          required={!workerFlag}
          id="emailWork"
          placeholder="Enter Email - Work"
          value={emailWork}
          name='emailWork'
          onChange={onChange}
        />
      </Col>

      {workerFlag && <Col lg="3" className="form-group m-0 p-2">
        <label htmlFor="prefEmail">
          Preferred Email
          {changeRequestedFields['contactInfo.preferredEmail'] && <CRBadge newValue={changeRequestedFields['contactInfo.preferredEmail'].newValue} />}
        </label>
        {(emailWork || emailPersonal) && <span aria-hidden="true" className="required"> *</span>}
        <FormSelect value={preferredEmail} required={emailWork || emailPersonal}
                    name='preferredEmail' onChange={onChange}
                    className='d-block'>
          <option value=''>Select Preferred Email</option>
          {preferredEmailListOption}
        </FormSelect>
      </Col>}

      {workerFlag && <Col lg="3" className="form-group m-0 p-2">
        <label htmlFor="linkedin">
          LinkedIn
          {changeRequestedFields['contactInfo.linkedIn'] && <CRBadge newValue={changeRequestedFields['contactInfo.linkedIn'].newValue} />}
        </label>
        <FormInput
          id="linkedin"
          placeholder="Enter Linkedin Url"
          value={linkedIn}
          name='linkedIn'
          onChange={onChange}
        />
      </Col>}
      
      
    </CustomCard>

  )
}


export default ContactInfo;
